export enum PublicLinkEntityEnumUi {
  project = 'project',
  section = 'section',
  block = 'block',
}
